import * as React from "react";
import classNames from "classnames";

type ClsAndChildProps = { className?: string; children?: React.ReactNode };

const MainContentLayout = ({ className, children, ...other }: ClsAndChildProps) => {
    return (
        <div {...other} className={classNames("content-layout vertical", className)}>
            {children}
        </div>
    );
};

const ContentLayoutHeader = ({ className, children, ...other }: ClsAndChildProps) => {
    return (
        <div {...other} className={classNames("content-layout-header", className)}>
            {children}
        </div>
    );
};
const ContentLayoutFooter = ({ className, children, ...other }: ClsAndChildProps) => {
    return (
        <div {...other} className={classNames("content-layout-footer", className)}>
            {children}
        </div>
    );
};

export type ContentLayoutCenterProps = {
    // Vertikální scrollbar
    scrollable?: boolean;
    // Scrollbar vždy
    alwaysScroll?: boolean;
};

const ContentLayoutCenter = ({
    className,
    children,
    scrollable,
    alwaysScroll,
    ...other
}: ClsAndChildProps & ContentLayoutCenterProps) => {
    return (
        <div
            {...other}
            className={classNames("content-layout-content", className, {
                scrollable,
                alwaysScroll,
            })}
        >
            {children}
        </div>
    );
};
const VerticalLayout = {
    Layout: MainContentLayout,
    Header: ContentLayoutHeader,
    Footer: ContentLayoutFooter,
    Center: ContentLayoutCenter,
};

export { VerticalLayout };
